<template>
  <div v-if="loading" class="icon-loader"></div>
  <div v-else>
    <span v-if="isValidNumber">
      {{ displayValue }}<span v-if="showPercentage">%</span>
    </span>
    <span v-else-if="value === null || value === 'null'"> - </span>
    <span v-else>{{ value }}<span v-if="showPercentage">%</span></span>
  </div>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    value: {
      type: [Number, String],
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isPercentage: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isValidNumber() {
      return typeof this.value === 'number' && !Number.isNaN(this.value)
    },
    displayValue() {
      // return this.value === 0 || this.value === '0' ? '-' : this.value
      return this.value
    },
    showPercentage() {
      return this.isPercentage
    },
  },
}
</script>

<style scoped>
.icon-loader {
  content: url(../assets/images/loading.gif);
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
